import { FittingProductModel } from "../product/fittingProductModel";

export class FittingsModel {
    magnetVentilsCount: number;
    holenderCount: number;
    couplingCount: number;
    nipelCount: number;
    tripleCount: number;
    ventilCount: number;
    elbowCount: number;
    autoFittings: Array<FittingProductModel>;
}